<template>
  <modal size="xl" @close="$emit('close')">
    <form class="flex flex-wrap w-full" @submit.prevent="submit">
      <div class="w-full mb-2 px-2">
        <nx-input
          type="date"
          label="Expires on"
          v-model="expired_at"
          id="expired_at"
          :errors="form.errors"
          info="Leave blank for a permanent ban."
          :focus="true"
        />
      </div>

      <div class="w-full mb-2 px-2">
        <nx-input
          label="Comment"
          v-model="comment"
          id="comment"
          :errors="form.errors"
          maxlength="1000"
        />
      </div>

      <div class="w-full">
        <nx-button
          native-type="submit"
          type="primary"
          :disabled="loading"
        >{{ loading ? 'Loading..' : 'Submit' }}</nx-button>
      </div>
    </form>
  </modal>
</template>

<script>
import Form from "form-backend-validation"

export default {
  name: "UserAdminBanForm",
  props: {
    existing: {
      required: true
    }
  },
  data() {
    return {
      form: new Form(),
      loading: false,
      type: "permanent",
      expired_at: "",
      comment: ""
    }
  },
  watch: {
    type(val) {
      if (val === "permanent") this.expired_at = null
    }
  },
  methods: {
    submit() {
      this.$api.users
        .ban(this.existing.username, {
          expired_at: this.expired_at,
          comment: this.comment
        })
        .then(() => {
          this.$toasted.success("User banned.")
          this.$emit("success")
        })
        .catch(data => {
          if (data.response && data.response.status === 422) {
            this.form.onFail(data)
            this.$error.form()
          } else {
            this.$error.generic()
          }
        })
    }
  }
}
</script>
